var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7449 4.64C15.0443 4.64 16.5953 5.61334 17.4796 6.42667L20.9354 3.12C18.813 1.18667 16.0511 0 12.7449 0C7.95581 0 3.81976 2.69334 1.80615 6.61334L5.76534 9.62667C6.75853 6.73334 9.50683 4.64 12.7449 4.64V4.64Z",
    fill: "#F25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 12.2667C24.5002 11.28 24.4186 10.56 24.2417 9.81335H12.7451V14.2667H19.4934C19.3574 15.3734 18.6227 17.04 16.99 18.16L20.854 21.0934C23.1669 19 24.5002 15.92 24.5002 12.2667V12.2667Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77891 14.3734C5.52041 13.6267 5.37075 12.8267 5.37075 12.0001C5.37075 11.1734 5.52041 10.3734 5.76531 9.62674L1.80612 6.6134C0.976191 8.24007 0.5 10.0667 0.5 12.0001C0.5 13.9334 0.976191 15.7601 1.80612 17.3867L5.77891 14.3734V14.3734Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.745 24C16.0511 24 18.8266 22.9333 20.8538 21.0933L16.9899 18.16C15.9559 18.8666 14.5681 19.36 12.745 19.36C9.5069 19.36 6.7586 17.2666 5.77901 14.3733L1.81982 17.3866C3.83343 21.3066 7.95588 24 12.745 24V24Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c3c7cb88fd1b5066f9ff0454d09b8067.svg";
export { ForwardRef as ReactComponent };